export const LiveDomains = [
  "best-jobs-online.com",
  "just-jobs.com",
  // "jifjaf.com"
  // "thejobexpert.com";
] as const;

export type PossibleGatsbyDomain = (typeof LiveDomains)[number];

export const LiveCountries = [
  "ae",
  "au",
  "br",
  "ca",
  "de",
  "es",
  "fr",
  "ie",
  "in",
  "it",
  "mx",
  "nl",
  "nz",
  "sg",
  "uk",
  "us",
  "za",
] as const;

export type PossibleGatsbyCountry = (typeof LiveCountries)[number];

export const lang = {
  ae: "ar",
  au: "en",
  br: "pt",
  ca: "en",
  de: "de",
  es: "es",
  fr: "fr",
  ie: "en",
  in: "en",
  it: "it",
  mx: "es",
  nl: "nl",
  nz: "en",
  sg: "en",
  uk: "en",
  us: "en",
  za: "en",
}[process.env.GATSBY_COUNTRY];
